//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import ContentLoader from 'react-content-loader'
//@end

//@import components
//@end

// @import hooks
import { useColors } from 'app_hooks/useColors'
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import '../simpleBoxLoaderCommon.scss'

// @ADD Component types
interface ISimpleBoxLoaderCommonLayoutProps {
  width?: number | string
  height?: number | string
  animationSpeed?: number
  borderRadius?: number | string
  backgroundColor?: string
  foregroundColor?: string
  style?: React.CSSProperties
}

const SimpleBoxLoaderCommonLayout: React.FC<ISimpleBoxLoaderCommonLayoutProps> = (props) => {

  const { t } = useTranslation()
  const [colors] = useColors()

  return(
    <ContentLoader
      speed={(props.animationSpeed) ? props.animationSpeed : 0}
      width={(props.width) ? props.width : 0}
      height={props.height ? props.height : 0}
      // viewBox={`0 0 ${props.width} ${props.height}`}
      backgroundColor={colors.placeholderBackground}
      foregroundColor={colors.placeholderForeground}
      // borderRadius={(props.borderRadius) ? props.borderRadius : 0}
      style={(props.style) ? props.style : {} }
    >
      <rect x='0' y='0' rx={props.borderRadius} ry={props.borderRadius} width={props.width} height={props.height} />
    </ContentLoader>
  )
}

export default SimpleBoxLoaderCommonLayout
